module.exports = __webpack_public_path__ + "img/depthqa.59c455d2.png";